export const GET_PRICES_INFOS_REQUEST = 'prices/GET_PRICES_INFOS_REQUEST';
export const GET_PRICES_INFOS_SUCCESS = 'prices/GET_PRICES_INFOS_SUCCESS';
export const GET_PRICES_INFOS_FAILED = 'prices/GET_PRICES_INFOS_FAILED';